export default {
  apiUrl: '/api/wines',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'wine-editor',
  onEachSide: 1,
  preloadList: [
    {
      name: 'wineries',
      target: 'getWineryList',
    },
    {
      name: 'regions',
      target: 'getRegionList',
    },
  ],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<p style="white-space: nowrap">아이디</p>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'is_checked',
      title: '<p style="white-space: nowrap">발행</p>',
      sortField: 'is_checked',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    {
      name: 'type',
      title: '<p style="white-space: nowrap">와인 색상</p>',
      sortField: 'type',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'wineColorField',
    },
    {
      name: 'img_bottle',
      title: '<p style="white-space: nowrap">사진</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      // callback: 'imgField',
      callback: 'imageField',
    },
    {
      name: 'wine_name',
      title: '<p style="white-space: nowrap">한글 이름</p>',
      sortField: 'wine_name',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'wine_name_en',
      title: '<p style="white-space: nowrap">영어 이름</p>',
      sortField: 'wine_name_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'short_wine_name',
      title: '<p style="white-space: nowrap">짧은 이름</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'is_sparkling',
      title: '<p style="white-space: nowrap">스파클링</p>',
      sortField: 'is_sparkling',
      titleClass: 'text-center',
      dataClass: 'text-center',
      callback: 'toggleField',
    },
    {
      name: 'region_name',
      title: '<p style="white-space: nowrap">지역</p>',
      sortField: 'region_name',
      titleClass: 'text-center',
      callback: 'subStringField',
    },
    {
      name: 'wine_dsc_short',
      title: '<p style="white-space: nowrap">간단한 설명</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'ellipsisStringField',
    },
    {
      name: 'winepoint',
      title: '<p style="white-space: nowrap">점수</p>',
      sortField: 'winepoint',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'price',
      title: '<p style="white-space: nowrap">가격</p>',
      sortField: 'price',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'numberCommaField',
    },
    // {
    //   name: 'is_nv',
    //   title: '<p style="white-space: nowrap">NV</p>',
    //   titleClass: 'text-center',
    //   dataClass: 'text-right',
    //   callback: 'toggleField',
    // },
    {
      name: 'vintage_year',
      title: '<p style="white-space: nowrap">빈티지</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    // {
    //   name: 'is_omit_type',
    //   title: '<p style="white-space: nowrap">색상 표기</p>',
    //   sortField: 'is_omit_type',
    //   titleClass: 'text-center',
    //   dataClass: 'text-center',
    //   callback: 'reverseToggleField',
    // },
    // {
    //   name: 'winery_id',
    //   title: '<p style="white-space: nowrap">생산자 아이디</p>',
    //   sortField: 'winery_id',
    //   titleClass: 'text-center',
    // },
    {
      name: 'winery_name',
      title: '<p style="white-space: nowrap">생산자</p>',
      sortField: 'winery_name',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    // {
    //   name: 'region_id',
    //   title: '<p style="white-space: nowrap">지역 아이디</p>',
    //   sortField: 'region_id',
    //   titleClass: 'text-center',
    // },
    // {
    //   name: '__slot:actions',
    //   title: '편집 삭제',
    //   titleClass: 'center aligned',
    //   dataClass: 'center aligned',
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/wine/product/Config.js